import * as actionsTypes from '../actions/actionsTypes';
import { updateObject } from '../../utils/utils';

const initialState = {
  aringToday: [],
  onAir: [],
  popularTv: [],
  topRatedTv: []
};

const fetchAringToday = (state, action) => {
  return updateObject(state, { aringToday: action.payload });
};

const fetchOnTheAir = (state, action) => {
  return updateObject(state, { onAir: action.payload });
};

const fetchPopularTv = (state, action) => {
  return updateObject(state, { popularTv: action.payload });
};

const fetchTopRatedTv = (state, action) => {
  return updateObject(state, { topRatedTv: action.payload });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionsTypes.FETCH_AIRING_TODAY_FULFILLED:
      return fetchAringToday(state, action);
    case actionsTypes.FETCH_ON_THE_AIR_FULFILLED:
      return fetchOnTheAir(state, action);
    case actionsTypes.FETCH_POPULAR_TV_FULFILLED:
      return fetchPopularTv(state, action);
    case actionsTypes.FETCH_TOP_RATED_TV_FULFILLED:
      return fetchTopRatedTv(state, action);

    default:
      return state;
  }
};

export default reducer;
